import { CourseStudentRest } from "@/services/rest/courses-student.rest";
import { GenericsUtils } from "@/utils/generics.util";
import { BehaviorSubject, Observable, map, take } from "rxjs";

export class LearningMapService {
  private classroomId: string | undefined;
  private classroomIdStudent: string | undefined;

  constructor(
    private _courses = new CourseStudentRest(),
    private _generics = new GenericsUtils()
  ) {
    this.classroomId = localStorage.getItem("classId") ?? undefined;
    this.classroomIdStudent =
      localStorage.getItem("stdClassroomId") ?? undefined;
  }

  private course$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  course: Observable<any> = this.course$.asObservable();

  private courses$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  courses: Observable<any> = this.courses$.asObservable();

  private trails$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  trails: Observable<any> = this.trails$.asObservable();

  private materials$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  materials: Observable<any> = this.materials$.asObservable();

  private material$: BehaviorSubject<any> = new BehaviorSubject<any>({});
  material: Observable<any> = this.material$.asObservable();

  private graphs$: BehaviorSubject<any> = new BehaviorSubject<any>({});
  graphs: Observable<any> = this.graphs$.asObservable();

  private learningMapStudent$: BehaviorSubject<any> = new BehaviorSubject<any>(
    {}
  );
  learningMapStudent: Observable<any> = this.learningMapStudent$.asObservable();

  role: string = "";

  getMaterialsById(objectiveId: string, materialId: string): void {
    this._courses
      .getMaterialById(objectiveId, materialId)
      .pipe(
        take(1),
        map((e) => {
          e.file.url = this._generics.getSecureUrl(e?.file?.url);
          e.file.mimetype = this._generics.getMimeType(e?.file?.mimetype);
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.material$.next(response);
        },
      });
  }
  getGraphsByCourse(courseId: string): void {
    this._courses
      .getGraphsByCourse(courseId, {
        classroomId: this.classroomId,
      })
      .subscribe({
        next: (response) => {
          this.graphs$.next(response);
        },
      });
  }
  getLearningMapStudent(courseId: string, userId: string): void {
    this._courses
      .getLearningMapStudent(courseId, userId, {
        classroomId: this.classroomId ?? this.classroomIdStudent,
      })
      .subscribe({
        next: (response) => {
          this.learningMapStudent$.next(response);
        },
      });
  }
}
